/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const ProspectingAndCitySchema = new Schema({
  prospectingId: {
    type: 'number'
  },
  cityId: {
    type: 'number'
  }
})

const ProspectingAndEstateTypeSchema = new Schema({
  prospectingId: {
    type: 'number'
  },
  estateType: {
    type: 'string'
  }
})

const ProspectingSchema = new Schema({
  archivedAt: {
    type: 'string',
    format: 'date-time'
  },
  bedrooms: {
    type: 'number',
    min: 1
  },
  cities: {
    type: 'array',
    items: {
      type: ProspectingAndCitySchema
    }
  },
  customerId: {
    type: 'number',
    required: true
  },
  equipped: {
    type: 'boolean'
  },
  furnished: {
    type: 'boolean'
  },
  maxPrice: {
    type: 'number',
    min: 1
  },
  minPrice: {
    type: 'number',
    min: 1
  },
  note: {
    type: 'string',
    maxLength: 1000
  },
  succeeded: {
    type: 'boolean'
  },
  transaction: {
    type: 'string',
    required: true
  },
  types: {
    type: 'array',
    minLength: 1,
    items: {
      type: ProspectingAndEstateTypeSchema
    },
    required: true
  }
})

export default ProspectingSchema
